<template>
 <div class="app-container">
  <SearchCollapse @update-height="getHeight" :formItemsLength="13">
   <div class="formBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
        <el-form-item label="捆包编号">
          <el-input  placeholder="可支持多个" type="textarea"  v-model="searchFrom.cargoBarcode"></el-input>
        </el-form-item>
        <el-form-item label="货权客户:">
          <el-input placeholder="" v-model="searchFrom.customerName" :readonly="true" ></el-input>
        </el-form-item>
        <el-form-item label="货物类型:" >
          <el-select  v-model="searchFrom.productTypeName" filterable placeholder="请选择">
            <el-option  label="全部" value="" ></el-option>
            <el-option v-for="item in HWlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卸点:">
          <el-input placeholder="" v-model="searchFrom.unloadingSite" ></el-input>
        </el-form-item>
         <el-form-item label="入库时间:" class="item2" >
          <el-date-picker
              v-model="searchFrom.createTimes"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
                 :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="仓位:" >
           <el-select v-model="searchFrom.warehouseId"  @change="changeXiugaiKW" placeholder="请选择">
              <el-option v-for="item in addKuwei" :label="item.warehouseName" :key="item.warehouseId" :value="item.warehouseId"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="区位:" >
          <el-select v-model="searchFrom.locationId" @change="changeXiugaiQW" placeholder="请选择">
            <el-option v-for="item in addQ" :label="item.locationName" :key="item.locationId" :value="item.locationId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货位:" >
          <el-select v-model="searchFrom.binId" size="mini" style="width:135px" @change="changeXiugaiHW" placeholder="请选择">
            <el-option v-for="item in addH" :label="item.binName" :key="item.binId" :value="item.binId"></el-option>
          </el-select>
        </el-form-item> -->
         <el-form-item label="仓位:">
          <el-input placeholder="" v-model="searchFrom.warehouseId" ></el-input>
        </el-form-item>
         <el-form-item label="区位:">
          <el-input placeholder="" v-model="searchFrom.locationId" ></el-input>
        </el-form-item>
        <el-form-item label="货位:">
          <el-input placeholder="" v-model="searchFrom.binId" ></el-input>
        </el-form-item>
        <el-form-item label="合同编号:">
          <el-input placeholder="" v-model="searchFrom.contractNumber" ></el-input>
        </el-form-item>
         <el-form-item label="合约编号:">
          <el-input placeholder="" v-model="searchFrom.agreementNumber" ></el-input>
        </el-form-item>
        <el-form-item label="首钢计划号:">
          <el-input placeholder="" v-model="searchFrom.billOfLadingNo" ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否短倒下车:">
          <el-select v-model="searchFrom.shortDropFlag" placeholder="请选择">
            <el-option label="全部" value="" ></el-option>
            <el-option label="是" value="1" ></el-option>
            <el-option label="否" value="" ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="状态:">
          <el-select v-model="searchFrom.matchStatus" placeholder="请选择">
            <el-option label="全部" value="" ></el-option>
            <el-option label="未配载" value="1" ></el-option>
            <el-option label="已配载" value="0" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="宽度:" class="kuanBox">
            <el-select size="mini" v-model="searchFrom.widthWhere" placeholder="请选择" >
              <el-option label="全部" value=""></el-option>
              <el-option label="大于等于" value="1"></el-option>
              <el-option label="小于等于" value="3"></el-option>
              <el-option label="等于" value="2"></el-option>
            </el-select>
            <el-input v-model="searchFrom.width" v-number-input.float="0" class="kuanBoxinp" placeholder="请输入" size="mini"
              ></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"  v-if="btnFlg[1]" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[2]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
            <el-button type="primary"  v-if="btnFlg[6]"   size="mini" @click="xiedianFN">修改卸点</el-button>
            <el-button type="primary" v-if="btnFlg[3]" size="mini" @click="peizaiFn">配载</el-button>
            <el-button type="primary"  size="mini" v-if="btnFlg[5]" @click="addTiDanFn">提单</el-button>
            <el-form-item style="margin-left:8px">
              <p class="margin0" >合计:<span class="red">{{total}}</span>件/<span class="red">{{allWeight}}</span>吨</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0" >已选:<span class="red">{{num}}</span>件/<span class="red">{{weight}}</span>吨</p>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    </SearchCollapse>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
       <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <div>
             <el-button type="text" size="mini" v-if="btnFlg[4]" @click="dapiaoFn(scope.row)">大票</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="status" label="状态"  width="100" >
          <template scope="scope">
            <div>
              <span  style="color: #D51212;" v-if="scope.row.status==='未配载'">{{scope.row.status}}</span>
              <span style="color: rgb(189 187 187);" v-else>{{scope.row.status}}</span>
            </div>
          </template>
          </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
          width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadingSite" label="卸点" align="center"
          min-width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="120"
          align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号" align="center"
             min-width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)" align="center"
          width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="货位" align="center" width="100">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.warehouseName }}</span>
                <span v-if='scope.row.locationName'>-{{ scope.row.locationName }}</span>
                <span v-if='scope.row.binName'>-{{ scope.row.binName }}</span>
              </div>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号" align="center"
             min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号" align="center"
             min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
             min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="billOfLadingNo" label="首钢计划号" align="center"
      min-width="160"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="number" label="是否短倒下车" align="center" min-width="120">
         <template slot-scope="scope">
            <div>
              <span v-if='scope.row.shortDropFlag==1'>是</span>
              <span v-else>否</span>
            </div>
        </template>
      </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="instockPlateNumber" label="入库车号" align="center"
               min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="入库时间"  align="center"
              width="180"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog  title="大票" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag"
      append-to-body width="800px" center>
      <div style="text-align: right;">
        <el-button type="primary" @click="dayinImgFn">打印</el-button>
        <div id="printMe"  ref="print">
          <el-image style="width: 100%;" :src="imgUrl" fit="contain" :preview-src-list="[imgUrl]"></el-image>
        </div>
      </div>
    </el-dialog>
    <!-- 首钢配载 -->
    <peizai v-if="peizaiFlag" :peizaiFlag.sync='peizaiFlag' :dataList="rowDataList"></peizai>
    <!-- 新增提单 -->
    <addtidan v-if="tidanFlag" :tidanFlag.sync='tidanFlag' :dataList="rowDataList"></addtidan>
    <!-- 修改卸点 -->

     <el-dialog  title="选择地址" :close-on-click-modal="false" :close-on-press-escape="false"  @close="xiedianFlag = false"
     :visible.sync="xiedianFlag" width="1300px" center append-to-body>
      <div>
        <publicAddress v-if="xiedianFlag" :iszujian="1" @handleCurrentChange="xuanzedizhiFn"></publicAddress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xiedianFlag = false">取 消</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getDictionaryDetailList, findSgStowageOrderGoodsYn, findSgStowageSonOrder, getWMSGoodsPlus, updateUnloadingSiteForTms } from '@/api/newTMS'
import peizai from '@/views/newTMS/transportation/shouGangPZ/peizai.vue'
import addtidan from '@/views/newTMS/transportation/shouGangPZ/addtidan.vue'
import publicAddress from '@/views/newTMS/publicFiles/publicAddress.vue'
import {
  zidianKuwei, // 字典库位
  zidianQuwei, // 字典区位
  zidianHuowei // 字典货位
} from '@/api/wms-stock'
import { getInStockTicket } from '@/api/wms-access'
import SearchCollapse from '@/components/common/SearchCollapse.vue'
export default {
  components: {
    peizai, addtidan, publicAddress, SearchCollapse
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        customerName: '中物唐山曹妃甸区物流有限责任公司'
      },
      total: 0,
      loading: false,
      HWlist: [],
      addKuwei: [],
      addQ: [],
      addH: [],
      allWeight: 0,
      weight: 0,
      num: 0,
      isDisable: false,
      rowDataList: [],
      peizaiFlag: false,
      lookImgFlag: false,
      imgUrl: '',
      tidanFlag: false,
      xiedianFlag: false,
      ids: '',
      btnFlg: [],
      btnIdArr: ['01N0130100', '01N0130200', '01N0130300', '01N0130400', '01N0130500', '01N0130600', '01N0130700']

    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
    // this.zidianKuweiS()
    this.btnFlg = getBtn(this.btnIdArr, '/shouGangPZ')
    this.getList()
  },
  mounted () {
    this.getHeight()
  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = (pH - h - 168) + 'px'
      })
    },
    // 修改卸点
    xiedianFN () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let idsArr = selectData.map(item => item.instockId)
      this.ids = idsArr.toString()
      this.xiedianFlag = true
    },
    xuanzedizhiFn (row) {
      console.log(12345)
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      updateUnloadingSiteForTms({
        instockIds: this.ids,
        unloadingSite: row.address,
        provinceCode: row.provinceCode,
        provinceName: row.provinceName,
        areaCode: row.areaCode,
        areaName: row.areaName,
        cityCode: row.cityCode,
        cityName: row.cityName
      }).then(res => {
        loading.close()
        this.xiedianFlag = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 提单
    addTiDanFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      let flag4 = selectData.every(item => !String(item.unloadingSite || '').includes('无地址'))
      if (!flag4) {
        this.$alert('卸点不能是"无地址"', '系统提示')
        return
      }
      let flag1 = selectData.every(item => item.productTypeName == '中厚板' || item.productTypeName == '剪切板')
      if (!flag1) {
        this.$alert('只有货物类型为中厚板或者剪切板的才能创建提单', '系统提示')
        return
      }
      let hwlx = selectData[0].productTypeName
      let flag3 = selectData.every(item => item.productTypeName == hwlx)
      if (!flag3) {
        this.$alert('货物类型一样才能创建提单', '系统提示')
        return
      }
      let xiedian = selectData[0].unloadingSite
      let flag2 = selectData.every(item => item.unloadingSite == xiedian)
      if (!flag2) {
        this.$alert('卸点一样得货物才能创建提单', '系统提示')
        return
      }
      this.tidanFlag = true
      this.rowDataList = selectData
    },
    checkSelectable (row) {
      if (row.status == '未配载') {
        return true
      } else {
        return false
      }
    },
    dapiaoFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在加载...'
      })
      getInStockTicket({
        instockId: row.instockId
      }).then(res => {
        this.lookImgFlag = true
        this.lookimgList = []
        if (res !== null) {
          this.imgUrl = res.fileKeyUrl
        }
        loading.close()
      })
    },
    dayinImgFn () {
      this.$print(this.$refs.print)
    },
    // 配载
    peizaiFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      let flag4 = selectData.every(item => !String(item.unloadingSite || '').includes('无地址'))
      if (!flag4) {
        this.$alert('卸点不能是"无地址"', '系统提示')
        return
      }
      // let productTypeName = selectData[0].productTypeName
      // let flag2 = selectData.every(item => item.productTypeName == productTypeName)
      // if (!flag2) {
      //   this.$alert('只有货物类型一样的才能进行配载', '系统提示')
      //   return
      // }
      // if (productTypeName != '冷卷' && productTypeName != '热卷') {
      //   this.$alert('货物类型只能选择冷卷或者热卷', '系统提示')
      //   return
      // }
      let flag1 = selectData.every(item => item.productTypeName == '中厚板' || item.productTypeName == '剪切板')
      if (flag1) {
        this.$alert('货物类型不能选择中厚板或者剪切板', '系统提示')
        return
      }
      this.rowDataList = []
      let obj = {}
      selectData.forEach(item => {
        if (!obj[item.unloadingSite + item.productTypeName]) {
          obj[item.unloadingSite + item.productTypeName] = []
        }
        obj[item.unloadingSite + item.productTypeName].push(item)
      })
      for (let key in obj) {
        let hwlxJson = this.HWlist.filter(item => item.showName == obj[key][0].productTypeName)
        let productType = ''
        if (hwlxJson.length == 1) {
          productType = hwlxJson[0].itemNo
        }
        this.rowDataList.push({
          measuringUnit: '吨',
          incomePattern: '0',
          makeTicketYn: '是',
          ticketSystemYn: '是',
          revenueValuation: '0',
          productTypeName: obj[key][0].productTypeName,
          productType: productType,
          tGoodsInfo: obj[key]
        })
      }
      this.peizaiFlag = true
    },
    groupBy (array, key) {
      return array.reduce((result, currentItem) => {
        if (!result[key]) {
          result[key] = []
        }
        // 将当前元素推入对应的数组
        result[key].push(currentItem)
        return result
      }, {})
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.tmsPlus + '/order/exportWMSGoodsPlus',
        form,
        '首钢配载'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({}).then(res => {
        this.addKuwei = res
      }).catch(err => {
        console.log(err)
      })
    },
    // 字典--区位
    zidianQuweiS (e) {
      zidianQuwei({
        warehouseId: e
      }).then(res => {
        this.addQ = res
      }).catch(err => {
        console.log(err)
      })
    },
    // 字典--货位
    zidianHuoweiS (e) {
      zidianHuowei({
        locationid: e
      }).then(res => {
        this.addH = res
      }).catch(err => {
        console.log(err)
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
      that.weight = that.weight.toFixed(3)
      this.num = selection.length
    },
    // 点击选中
    handleRowClick (row, column, event) {
      if (row.status == '未配载') {
        this.$refs.table.toggleRowSelection(row)
      }
    },
    // 获取列表
    getList () {
      if (this.searchFrom.createTimes) {
        this.searchFrom.offerStartTime = this.searchFrom.createTimes[0]
        this.searchFrom.offerEndTime = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.offerStartTime = null
        this.searchFrom.offerEndTime = null
      }

      this.loading = true
      getWMSGoodsPlus(this.searchFrom).then(res => {
        this.allWeight = res.allWeight.allWeight
        this.tableList = res.pageInfo.list
        this.total = res.pageInfo.total
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        customerName: '中物唐山曹妃甸区物流有限责任公司'
      }
    },
    closeDialog () {
      this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 430px!important;
}
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 280px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      width: 540px;
   }
}
.kuanBox{
  /deep/.el-select{
    width: 50%!important;
  }
  /deep/.kuanBoxinp{
    width: 50%!important;
  }
}
</style>
